import React, { useState, useEffect } from 'react';
import SportsScheduleTable from './components/SportsScheduleTable';
import Login from './components/Login';
import UsersManagement from './components/UsersManagement';
import EventAuditPage from './components/EventAuditPage';
import DebugPanel from './components/DebugPanel';
import './App.css';

// Релиз: дебаг-панель только при REACT_APP_DEBUG=true (для разработки)
const SHOW_DEBUG = process.env.REACT_APP_DEBUG === 'true';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showUsersManagement, setShowUsersManagement] = useState(false);
  const [showEventAudit, setShowEventAudit] = useState(false);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || 'user');

  useEffect(() => {
    // Проверяем наличие токена при загрузке
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      // Обновляем роль из localStorage
      const role = localStorage.getItem('userRole') || 'user';
      setUserRole(role);
    }
    setLoading(false);
  }, []);

  // Слушаем изменения в localStorage для обновления роли
  useEffect(() => {
    const handleStorageChange = () => {
      const role = localStorage.getItem('userRole') || 'user';
      setUserRole(role);
    };

    // Слушаем изменения в localStorage
    window.addEventListener('storage', handleStorageChange);
    
    // Также проверяем при каждом рендере (на случай изменений в том же окне)
    const interval = setInterval(() => {
      const role = localStorage.getItem('userRole') || 'user';
      if (role !== userRole) {
        setUserRole(role);
      }
    }, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [userRole]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    // Обновляем роль после логина
    const role = localStorage.getItem('userRole') || 'user';
    setUserRole(role);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setUserRole('user');
  };

  if (loading) {
    return <div className="App">Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
            <Login onLogin={handleLogin} />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-header">
        <h1 className="app-title">Календарь спортивных мероприятий</h1>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          {userRole === 'admin' && (
            <>
              <button
                onClick={() => setShowEventAudit(true)}
                className="users-management-btn"
              >
                Журнал мероприятий
              </button>
              <button
                onClick={() => setShowUsersManagement(true)}
                className="users-management-btn"
              >
                Управление пользователями
              </button>
            </>
          )}
          <button
            onClick={handleLogout}
            className="logout-btn"
          >
            Выйти
          </button>
        </div>
      </div>
      {showEventAudit ? (
        <EventAuditPage onBack={() => setShowEventAudit(false)} />
      ) : (
        <SportsScheduleTable />
      )}
      {showUsersManagement && (
        <UsersManagement onClose={() => setShowUsersManagement(false)} />
      )}
      {SHOW_DEBUG && <DebugPanel />}
    </div>
  );
}

export default App;
